
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Diagnose from '@/types/Diagnose';
    import {
        DeleteDiagnosePayload,
        DiagnosenFilter,
        UpdateDiagnosePayload,
    } from '@/store/diagnosen';
    import { VCurrencyField, VForm } from '@/types/Components';
    import { confirmSwal } from '@/helper/swals';
    import api from '@/services/Api';
    import { AxiosResponse } from 'axios';
    import DiagnosenDiagnosenbezeichnungen from '@/components/Diagnosen/DiagnosenDiagnosenbezeichnungen.vue';

    @Component({
        components: {
            DiagnosenDiagnosenbezeichnungen,
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('diagnosen', ['diagnosen', 'loaders']),
        },
        methods: {
            ...mapActions('diagnosen', ['updateDiagnose', 'deleteDiagnose']),
        },
    })
    export default class DiagnosenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() diagnose!: Diagnose;
        @Prop() filter!: DiagnosenFilter;

        public $refs!: {
            form: VForm;
            verkaufspreis: VCurrencyField;
        };

        public diagnosee!: Diagnose[];
        public updateDiagnose!: (payload: UpdateDiagnosePayload) => Promise<void>;
        public deleteDiagnose!: (payload: DeleteDiagnosePayload) => void;

        public loadingDiagnosenbezeichnungen = false;
        public diagnosenbezeichnungenError = false;
        public textErrorMessage = '';
        public tabIndex = 'tab-allgemein';
        public diagnoseName = '';

        public get isEdit(): boolean {
            return this.diagnose.diagnose_id !== null;
        }

        public get folgediagnosee(): Diagnose[] {
            return this.diagnosee.filter(({ diagnose_id }) => diagnose_id !== this.diagnose.diagnose_id);
        }

        public get textLabelClass(): string {
            return this.textErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.tabIndex = 'tab-allgemein';
                this.diagnoseName = this.diagnose.diagnose ?? '';
                this.textErrorMessage = '';

                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                this.loadDiagnosenbezeichnungen();
            }
        }

        @Watch('diagnose.diagnose_id')
        public onChangediagnose(diagnose_id: number | null): void {
            if (diagnose_id) {
                this.loadDiagnosenbezeichnungen();
                this.diagnoseName = this.diagnose.diagnose ?? '';
            }
        }

        public loadDiagnosenbezeichnungen(): void {
            this.loadingDiagnosenbezeichnungen = true;

            api.post('verwaltung/diagnosenbezeichnungen/load', { diagnose_id: this.diagnose.diagnose_id })
                .then((response: AxiosResponse) => (this.diagnose.diagnosenbezeichnungen = response.data.body))
                .catch(console.error)
                .finally(() => this.loadingDiagnosenbezeichnungen = false);
        }

        public onClickSave(): void {
            this.diagnosenbezeichnungenError = this.diagnose.diagnosenbezeichnungen
                .some((diagnosenbezeichnung) => diagnosenbezeichnung.bezeichnung === null) ?? false;

            if (this.$refs.form.validate() && !this.diagnosenbezeichnungenError) {
                this.updateDiagnose({ diagnose: this.diagnose, filter: this.filter })
                    .then(() => this.diagnoseName = this.diagnose.diagnose ?? '');
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Diagnose endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteDiagnose({ diagnose: this.diagnose, filter: this.filter });
                    }
                });
        }
    }
